export default __webpack_public_path__ + "img/video-camera-gray.880d7911.svg";